import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { getStudentInvoiceDetailsById } from '@app/services/student';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import InvoicePaymentHistoryModal from './InvoicePaymentHistoryModal';
import { Button } from 'react-bootstrap';

const ViewStudentInvoiceDetails = () => {

    let obj: any = {}
    let { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [invoice, setInvoice] = useState(obj);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const invoiceStatuses = [{label:'Cancelled', value:'cancelled'}, {label:'Mirrored', value:'mirrored'}, {label:'Paid', value:'paid'}, {label:'Partially Paid', value:'partially-paid'}, {label:'Reversed', value:'reversed'}, {label:'Unpaid', value:'unpaid'}]

    useEffect(() => {
        getInvoiceDetailsById(id)
    },[]);

     const getInvoiceStatusClass = (status) => {
        switch (status) {
            case 'paid':
                return 'bg-success';
            case 'unpaid': 
                return 'bg-warning';
            case 'mirrored':
                return 'bg-info';
            case 'partially-paid':
                return 'bg-secondary';
            case 'cancelled':
            case 'reversed':
                return 'bg-danger';
            default:
                return 'bg-warning';
        }
    };
    
    const getInvoiceDetailsById = async (id) => {
        try {
            setLoading(true);
            const resp = await getStudentInvoiceDetailsById(id);
            if(resp.success === true){
                setLoading(false);
                setInvoice(resp.collections);
                setPaymentHistory(resp?.collections?.payment_history)
                if(Object.keys(resp?.collections).length == 0){
                    setLoading(false);
                    toast.error('Something went wrong');
                    navigate('/student-invoices');
                }                    
            }else{
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
                navigate('/student-invoices');
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
            navigate('/student-invoices');
        }
    };

    const removePrefix = (str: string, prefix: string): string =>
        str.startsWith(prefix) ? str.slice(prefix.length) : str;
    
    return (
        <div>
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {/* Main content */}
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">View Invoice Details</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Invoice Number</dt>
                                                <dd>#{ invoice?.invoice_number ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Student Name</dt>
                                                <dd>{ invoice?.student_name ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Franchise</dt>
                                                <dd>{ invoice?.franchise_name ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Invoice Date </dt>
                                                <dd>{ invoice?.invoice_date ? moment(invoice?.invoice_date).format('DD/MM/YYYY') : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Invoice Duration </dt>
                                                <dd>{ invoice?.invoice_from_date ? moment(invoice?.invoice_from_date).format('DD/MM/YYYY') + ' - ' + moment(invoice?.invoice_to_date).format('DD/MM/YYYY') : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Invoice Due Date </dt>
                                                <dd>{ invoice?.invoice_due_date ? moment(invoice?.invoice_due_date).format('DD/MM/YYYY') : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Invoice Status </dt>
                                                <dd><span className={ `badge ${getInvoiceStatusClass(invoice?.invoice_status)}` }>{ invoice.invoice_status ? (invoiceStatuses.find(obj => { return obj.value === invoice.invoice_status}))?.label : '---' }</span></dd>
                                            </div>
                                        </div>
                                        { invoice?.document_type === 'credit_note' && (
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <dt>Original Invoice Number </dt>
                                                    <dd>{ invoice?.invoice_number ? removePrefix(invoice?.invoice_number, "CN-") : '---' }</dd>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="invoice p-3 mb-3">
                                        <div className="row invoice-info">
                                            <div className="col-sm-4 invoice-col">
                                                From
                                                <address>
                                                    <strong>{ invoice?.franchise_name }</strong><br />
                                                    { invoice?.franchise_address ?? '---'}<br />
                                                    Phone: { invoice?.franchise_phone ?? '---'}<br />
                                                    Email: { invoice?.franchise_email ?? '---'}
                                                </address>
                                            </div>
                                            {/* /.col */}
                                            <div className="col-sm-4 invoice-col">
                                                To
                                                <address>
                                                    <strong>{ invoice?.parent?.name ?? '---'}</strong><br />
                                                    { invoice?.parent?.address }<br />
                                                    Phone: { invoice?.parent?.phone }<br />
                                                    Email: { invoice?.parent?.email }
                                                </address>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                        {/* Table row */}
                                        <div className="row">
                                            <div className="col-12 table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Type</th>
                                                            <th>Description</th>
                                                            <th>Net</th>
                                                            <th>VAT</th>
                                                            <th>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        { invoice?.subject_fee && invoice?.subject_fee.map((row, i) => (
                                                            <tr key={'subject_fee' + i}>
                                                                <td>Subject Fee</td>
                                                                <td>{ row?.name }</td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.net_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.vat_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.total_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                        ))}

                                                        { invoice?.fees && invoice?.fees.map((row, i) => (
                                                            <tr key={'fees' + i}>
                                                                <td>Fee</td>
                                                                <td>{ row?.description }</td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.net_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.vat_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.invoiced_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                        ))}

                                                        {/* { invoice?.credits && invoice?.credits.map((row, i) => (
                                                            <tr key={'credits' + i}>
                                                                <td>Credit</td>
                                                                <td>{ row?.description }</td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.net_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.vat_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                                <td><CurrencyFormat value={ (parseFloat(row?.invoiced_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                        ))} */}
                                                        
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                        {/* /.row */}
                                        <div className="row">
                                            <div className="col-6">
                                                
                                            </div>
                                            {/* /.col */}
                                            <div className="col-6">
                                                {/* <p className="lead">Amount Due 2/22/2014</p> */}
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <th style={{width: '50%'}}>Net :</th>
                                                                <td><CurrencyFormat value={ (parseFloat(invoice?.total_net_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                            <tr>
                                                                <th>VAT { invoice?.vat_percent ? `(${invoice?.vat_percent} %)`: ''} :</th>
                                                                <td><CurrencyFormat value={ (parseFloat(invoice?.total_vat_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                            { invoice?.credits && invoice?.credits.length > 0 && (
                                                                <tr>
                                                                    <th>Credit Used :</th>
                                                                    <td><CurrencyFormat value={ (parseFloat(invoice?.credit_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={invoice?.franchise_currency + ' - '} /></td>
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <th>Total Payable:</th>
                                                                <td><b><CurrencyFormat value={ (parseFloat(invoice?.total_payable_amount)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={invoice?.franchise_currency + ' '} /></b></td>
                                                            </tr>
                                                            <tr>
                                                                <th>Amount Paid:</th>
                                                                <td><CurrencyFormat value={ (parseFloat(invoice?.amount_paid)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={invoice?.franchise_currency + ' '} /></td>
                                                            </tr>
                                                            <tr>
                                                                <th>Outstanding Amount:</th>
                                                                <td><b><CurrencyFormat value={ (parseFloat(invoice?.amount_outstanding)).toFixed(2) } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={invoice?.franchise_currency + ' '} /></b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                        {/* /.row */}
                                    </div> {/* /.invoice */}
                                    <div className="row no-print">
                                        <div className="col-12">
                                            <Button className="btn btn-default" onClick={() => navigate(-1)}>Back</Button>
                                            <button type="button" className="btn btn-success float-right" onClick={handleShow} ><i className="far fa-credit-card" /> Payment History </button>
                                        </div>
                                    </div>
                                </div>{/* /.card-body */}
                            </div>{/* /.card-body */}
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </section>
            {/* /.content */}
            <InvoicePaymentHistoryModal
                show={show}
                handleClose={handleClose}
                paymentHistory={paymentHistory}
                currency={invoice?.franchise_currency}
                invoiceNumber={invoice?.invoice_number}
            />
        </div>
    )
};

export default ViewStudentInvoiceDetails;